import type { PrivacyContent } from "@/types/privacy";

const privacyContent: PrivacyContent = {
  "title": "AptFleet Cookie and Privacy Policy",
  "effectiveDate": "14 Feb 2025",
  "introduction": "This Cookie and Privacy Policy explains how Twinhelix Services Ltd (\"Company,\" \"we,\" \"us,\" or \"our\") collects, uses, and protects information through AptFleet (\"Service\") and its related services. This policy also describes how we use cookies and similar technologies to enhance your experience on our platform. By accessing or using our Service, you agree to the practices described in this policy.",
  "sections": [
    {
      "id": "definitions",
      "title": "1. Definitions",
      "content": [
        "\"Personal Data\" refers to any information relating to an identified or identifiable natural person.",
        "\"Cookies\" are small text files that are placed on your device to collect data and improve your experience on our Service.",
        "\"Service\" refers to the AptFleet platform and any related services provided by the Company.",
        "\"Data Subject\" means an individual whose Personal Data is collected or processed by the Company."
      ]
    },
    {
      "id": "data-collection",
      "title": "2. Data Collection",
      "content": [
        "We collect Personal Data that you voluntarily provide when using our Service, such as your name, email address, and business details.",
        "Our Service may automatically collect information about your device, browser, and usage patterns through cookies and similar technologies."
      ]
    },
    {
      "id": "use-of-cookies",
      "title": "3. Use of Cookies",
      "content": [
        "Cookies help us recognise your device and understand how you use our Service, allowing us to improve its functionality and your overall experience.",
        "We use both session cookies (which expire after you close your browser) and persistent cookies (which remain on your device until they expire or are deleted).",
        "You can manage or disable cookies through your browser settings, but please note that this may affect the functionality of our Service."
      ]
    },
    {
      "id": "data-use",
      "title": "4. Use of Personal Data",
      "content": [
        "We use your Personal Data to provide and improve our Service, communicate with you about updates or changes, and personalise your experience.",
        "Your data may be used for security purposes, analytics, and to comply with legal obligations."
      ]
    },
    {
      "id": "data-sharing",
      "title": "5. Data Sharing and Third Parties",
      "content": [
        "We do not sell or rent your Personal Data. However, we may share your information with trusted third-party service providers who help us operate our Service, subject to confidentiality agreements.",
        "We may also disclose your Personal Data if required by law or to protect our rights, property, or safety."
      ]
    },
    {
      "id": "data-security",
      "title": "6. Data Security",
      "content": [
        "We implement appropriate technical and organisational measures to safeguard your Personal Data against unauthorised access, alteration, disclosure, or destruction.",
        "While we strive to protect your data, no method of transmission over the Internet or electronic storage is 100% secure."
      ]
    },
    {
      "id": "data-retention",
      "title": "7. Data Retention",
      "content": [
        "We retain your Personal Data for as long as necessary to fulfill the purposes for which it was collected, to comply with legal obligations, and to enforce our agreements."
      ]
    },
    {
      "id": "your-rights",
      "title": "8. Your Rights",
      "content": [
        "You have the right to access, correct, or delete your Personal Data held by us, subject to certain legal exceptions.",
        "If you have questions about your rights or wish to exercise them, please contact us using the information provided in the Contact Information section."
      ]
    },
    {
      "id": "policy-updates",
      "title": "9. Policy Updates",
      "content": [
        "We may update this Cookie and Privacy Policy from time to time. Any changes will be posted on this page along with the updated effective date.",
        "Your continued use of the Service after any changes constitutes your acceptance of the revised policy."
      ]
    },
    {
      "id": "contact-information",
      "title": "10. Contact Information",
      "content": [
        "If you have any questions or concerns about this Cookie and Privacy Policy or our data practices, please contact us at:",
        "Email: support@aptfleet.com",
        
      ]
    }
  ],
  contactInfo: "If you have any questions or concerns about this Cookie and Privacy Policy or our data practices, please contact us at:"
}

export default privacyContent;